import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  discountPharmaciesContainer: ({ colors, spacing, typography, grid }) => css`
    h2 {
      color: ${colors.neutral[500]};
      margin-bottom: ${spacing.xxs};
      ${typography.headingLarge};
    }

    p {
      color: ${colors.neutral[400]};
      margin-top: ${spacing.xs};
    }

    @media (min-width: ${grid.breakpoint.md}) {
      p {
        max-width: 598px;
      }
    }
  `,
  containerText: ({ colors }) => css`
    display: flex;

    a {
      color: ${colors.brand.primary[300]};
    }
  `,
  container: ({ spacing }) => css`
    margin: ${spacing.xs} 0;
  `,
})

export default useStyles
